module.exports = __webpack_public_path__ + "static/media/ky.b7acd796.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/ky.svg
// module id = 907
// module chunks = 0